import actions from '@/store/modules/finances/deep-cloud-login/actions';
import mutations from '@/store/modules/finances/deep-cloud-login/mutations';
import initialState from '@/store/modules/finances/deep-cloud-login/state';

export default {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
};
